import { Component, OnInit } from '@angular/core';
import { AppstyleService } from 'src/core/appstyle/appstyle.service';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Consulta } from 'src/core/consulta/consulta.types';

@Component({
  selector: 'app-inicio-client',
  templateUrl: './inicio-client.component.html',
  styleUrls: ['./inicio-client.component.css'],
})
export class InicioClientComponent implements OnInit{
  consultas: Consulta[] = [];

  constructor(
    private _styleService: AppstyleService,
    private _consultaService: ConsultaService
    ) { }

  ngOnInit(): void {
    this.getConsultas();
  }

  getConsultas(){
    this._consultaService._consultasUsuarioClient$.subscribe({
      next: (response: Consulta[]) => {
        this.consultas = response;
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

}
